import { observable, action } from 'mobx';

class SessionStore {
  @observable authUser = null;

  constructor(Store) {
    this.Store = Store;
  }

  @action setAuthUser = authUser => {
    this.authUser = authUser;
  }
}

export default SessionStore;



// WEBPACK FOOTER //
// ./src/stores/sessionStore.js